import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from '../../environments/environment';
import { BooleanBaseResponseDto, CreateEnrollmentDraftResponseBaseResponseDto, EnrollmentDraft, VerifyEmailRequest, VerifyEmailResponseBaseResponseDto, CompleteEnrollmentRequest, CheckDraftStatusResponseBaseResponseDto } from '../models/api-data-contracts';
import { Observable } from 'rxjs';
import { BaseService } from './base.service';
import { TurnstileTokenService } from './turnstile-token.service';

@Injectable({
  providedIn: 'root'
})
export class EnrollmentService extends BaseService {

  constructor(
    private http: HttpClient,
    protected override turnstileTokenService: TurnstileTokenService
  ) { 
    super(turnstileTokenService);
  }
  
  url = `${environment.ApiURL}/enrollment`;

  createDraft(data: EnrollmentDraft, includeTurnstile: boolean = false): Observable<CreateEnrollmentDraftResponseBaseResponseDto> {
    const headers = this.getHeaders('', includeTurnstile);
    return this.http.post<CreateEnrollmentDraftResponseBaseResponseDto>(`${this.url}/draft`, data, { headers: headers });
  }

  updateDraft(sessionToken: string, data: EnrollmentDraft, resendOtp: boolean = false, includeTurnstile: boolean = false): Observable<CreateEnrollmentDraftResponseBaseResponseDto> {
    const headers = this.getHeaders('', includeTurnstile);
    const params = resendOtp ? { resendOtp: 'true' } : {};
    return this.http.put<CreateEnrollmentDraftResponseBaseResponseDto>(`${this.url}/draft/${sessionToken}`, data, { headers: headers, params: params });
  }

  verifyEmail(data: VerifyEmailRequest): Observable<VerifyEmailResponseBaseResponseDto> {
    const headers = this.getHeaders('', false);
    return this.http.post<VerifyEmailResponseBaseResponseDto>(`${this.url}/verify-email`, data, { headers: headers });
  }

  completeEnrollment(data: CompleteEnrollmentRequest): Observable<BooleanBaseResponseDto> {
    const headers = this.getHeaders('', true); // Only this call needs Turnstile token
    return this.http.post<BooleanBaseResponseDto>(`${this.url}/complete`, data, { headers: headers });
  }

  checkDraftStatus(sessionToken: string): Observable<CheckDraftStatusResponseBaseResponseDto> {
    const headers = this.getHeaders('', false);
    return this.http.get<CheckDraftStatusResponseBaseResponseDto>(`${this.url}/draft/${sessionToken}`, { headers: headers });
  }

}
